import { Link } from "react-router-dom";
import { useCart } from "@/App";
import { Button } from "@/components/ui/button";
import { X, GitCompare } from "lucide-react";

export default function CompareBar() {
  const { compareList, removeFromCompare, clearCompare } = useCart();

  if (compareList.length === 0) return null;

  return (
    <div className="fixed bottom-16 md:bottom-0 left-0 right-0 z-30 compare-bar text-white py-3 px-4 no-print" data-testid="compare-bar">
      <div className="max-w-7xl mx-auto flex items-center justify-between gap-4">
        <div className="flex items-center gap-3 flex-1 overflow-x-auto no-scrollbar">
          <GitCompare className="w-5 h-5 flex-shrink-0" />
          <span className="font-semibold whitespace-nowrap">Comparando {compareList.length} producto(s)</span>
          
          <div className="flex items-center gap-2">
            {compareList.map((product) => (
              <div
                key={product.product_id}
                className="flex items-center gap-2 bg-white/10 rounded px-2 py-1"
              >
                {product.images?.[0] && (
                  <img
                    src={product.images[0]}
                    alt={product.name}
                    className="w-8 h-8 object-cover rounded"
                  />
                )}
                <span className="text-sm truncate max-w-24">{product.name}</span>
                <button
                  onClick={() => removeFromCompare(product.product_id)}
                  className="text-white/60 hover:text-white"
                >
                  <X className="w-4 h-4" />
                </button>
              </div>
            ))}
          </div>
        </div>

        <div className="flex items-center gap-2 flex-shrink-0">
          <Button
            variant="ghost"
            size="sm"
            onClick={clearCompare}
            className="text-white hover:bg-white/10"
          >
            Limpiar
          </Button>
          <Link to="/comparador">
            <Button size="sm" className="bg-accent hover:bg-accent/90 text-white font-bold uppercase tracking-wide">
              Comparar
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
